import {
	TableRow as TableRowMui,
	TableRowProps as TableRowPropsMui,
} from '@mui/material';

import styled from 'styled-components';

type TableRowProps = TableRowPropsMui;

const StyledTableRow = styled(TableRowMui)`
	& > th {
		padding-left: 20px !important;
	}
	& > th > span {
		white-space: nowrap !important;
	}
`;

const TableRowHeader: React.FC<TableRowProps> = props => {
	return <StyledTableRow {...props}>{props.children}</StyledTableRow>;
};

export default TableRowHeader;
